// @flow

import {getAllIds} from '@pb/kit-component-tree-v2';
import {getDisabledIdsList} from './getDisabledIdsList';

import type {TreeItem} from '@pb/kit-component-tree-v2';

export const updateCheckedIdsList = ({data, checked, checkedIdsList}: {
    data: TreeItem,
    checked: boolean,
    checkedIdsList: Array<string>,
}): Array<string> => {
    const disabledIds = getDisabledIdsList([data]);
    const allIds = getAllIds([data]).filter(id => !disabledIds.includes(id));

    return checked
        ? checkedIdsList
            .concat(allIds)
            .filter(
                (id, index, self) => self.indexOf(id) === index
            )
        : checkedIdsList
            .filter(
                checkedId => !allIds.includes(checkedId)
            );
};
